module.exports = __webpack_public_path__ + "static/media/evoke-logo-no-background.87a5c40b.svg";